import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '@vendasta/store';

@Component({
  selector: 'work-order-form-conflict-dialog',
  templateUrl: './form-conflict-dialog.component.html',
  styleUrls: ['./form-conflict-dialog.component.scss'],
})
export class FormConflictDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<FormConflictDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  handleRefreshPage(): void {
    window.location.reload();
  }
}
